import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer-container'>
      <section class='social-media'>
        <div class='social-media-wrap'>
        <div>
            <a
              class='social-logo'
              href= 'https://apps.apple.com/us/app/aus-tax-calculator/id6701995913'
              target='_blank'
              rel="noreferrer"
            >
              <i class='fa-brands fa-app-store-ios' />
            </a>
            </div>
          <small class='website-rights'>DD © {new Date().getFullYear()}</small>
          <div class='social-icons'>
            <a
              class='social-icon-link facebook'
              href= 'https://www.facebook.com/deepesh.dhakal44/'
              target='_blank'
              rel="noreferrer"
              aria-label='Facebook'
            >
              <i class='fab fa-facebook-f' />
            </a>
            <a
              class='social-icon-link twitter'
              href='https://twitter.com/DeepeshDhakal44'
              target='_blank'
              rel="noreferrer"
              aria-label='Twitter'
            >
              <i class='fab fa-twitter' />
            </a>
            <a
              class='social-icon-link github'
              href='https://github.com/dipeshdhakal'
              target='_blank'
              rel="noreferrer"
              aria-label='Github'
            >
              <i class='fab fa-github' />
            </a>
            <a
              class='social-icon-link linkedin'
              href='https://www.linkedin.com/in/dipesh-dhakal-29b9779a/'
              target='_blank'
              rel="noreferrer"
              aria-label='LinkedIn'
            >
              <i class='fab fa-linkedin' />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
